<script>
import ChatAca from "./components/ChatAca.vue";
export default {
    components: {
        ChatAca,
    },
    data() {
        return {
            ActiveTab: "",
            showPlugin: false,
        };
    },
    computed: {
        ag() {
            return this.$parent.ag;
        },
        wid() {
            return this.$parent.wid;
        },
        Setting() {
            return this.$parent.Settings;
        },
        Translation() {
            return this.$parent.Translation;
        },
    },
    mounted() {
        if (window.innerWidth > 991) {
            this.showPlugin = false;
        }
    },
};
</script>
<template>
    <div class="plugin" :class="{show: showPlugin}">
        <div class="plugin-head" role="button" @click="showPlugin = !showPlugin">
            <div class="plugin-icon"></div>
            <div class="plugin-text">
                <h5 class="title">University Admission</h5>
                <p class="desc">After OHLA ESL Program</p>
            </div>
        </div>
        <button type="button" class="btn btn-close" @click="showPlugin = !showPlugin"></button>
        <div class="plugin-content">
            <ChatAca />
            <p class="fs-7 mb-0 lh-sm fw-500 mt-2 text-center">In partnership with</p>
            <a href="https://uniapplynow.com" target="_blank" rel="noopener noreferrer" role="button">
                <img src="https://studentpanel.net/widget/icons/uniapplynow-light.png" alt="*" class="img-fluid mx-auto d-block" width="190" />
            </a>
        </div>
    </div>
</template>
